import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SyncoInvitePeopleIcon = (props: IconProps) => (
  <Icon w="146px" h="56px" viewBox="0 0 146 56" {...props} fill="none">
    <mask
      id="mask0_4084_1903"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="15"
      width="41"
      height="41"
    >
      <circle cx="20.5" cy="35.5" r="20.5" fill="#B94C24" />
    </mask>
    <g mask="url(#mask0_4084_1903)">
      <rect
        x="-6.56006"
        y="7.20996"
        width="81.18"
        height="77.49"
        fill="#C5B3EC"
      />
      <path
        d="M25.885 62.7473C38.0287 55.601 28.9352 26.2209 28.9352 26.2209C28.9352 26.2209 16.5238 23.0168 15.1447 26.2858C9.98549 38.518 0.0563948 56.7042 3.33365 63.4367C5.30487 67.4844 22.4455 64.7833 25.8931 62.7554L25.885 62.7473Z"
        fill="#282644"
      />
      <path
        d="M11.105 48.3736C11.105 48.3736 1.23266 55.0981 -1.61466 84.0563C-3.6021 104.335 -5.32996 111.473 -5.32996 111.473L0.486355 111.555C0.486355 111.555 11.8594 83.1397 12.8896 70.5263C13.3763 64.5643 11.105 48.3655 11.105 48.3655V48.3736Z"
        fill="#7B7B7B"
      />
      <path
        d="M32.3504 48.1057C32.3504 48.1057 43.8045 52.5833 46.3111 83.2369C47.9741 103.548 49.6776 111.473 49.6776 111.473L43.8613 111.554C43.8613 111.554 32.4883 83.1395 31.458 70.5261C30.9713 64.5641 32.3504 48.1057 32.3504 48.1057Z"
        fill="#7B7B7B"
      />
      <path
        d="M18.714 45.9481C14.9987 46.1752 10.9022 46.8322 9.75837 50.7095C8.98773 55.9983 11.5187 72.9109 8.32254 90.2209C3.82037 114.588 4.77759 140.975 4.77759 140.975L40.3001 141.243C40.3001 141.243 40.7544 114.588 37.1121 90.4886C34.646 74.1682 36.6902 58.0667 34.3945 50.7095C33.1859 46.8322 27.3777 46.451 25.4064 45.9562C23.0215 44.9503 21.8777 45.7615 18.714 45.9562V45.9481Z"
        fill="#7B7B7B"
      />
      <path
        d="M14.9907 32.4911C14.9907 32.4911 14.1551 27.8513 15.6396 24.9879C17.5054 21.3864 23.0864 19.399 27.3777 23.2358C30.371 25.9045 28.7973 32.9534 28.7973 32.9534L19.436 28.9707L14.9988 32.4911H14.9907Z"
        fill="#282644"
      />
      <path
        d="M25.3983 45.9482C25.3983 45.9482 21.4721 48.0247 18.7059 45.9482L19.2981 38.7451H24.8143L25.3983 45.9482Z"
        fill="#D57D7B"
      />
      <path
        d="M16.1588 31.6719C16.1588 31.6719 15.3638 31.1608 14.7554 31.9801C14.1389 32.7994 14.5526 35.8574 16.0858 35.8574C17.619 35.8574 16.1588 31.6719 16.1588 31.6719Z"
        fill="#D57D7B"
      />
      <path
        d="M27.9942 31.6719C27.9942 31.6719 28.7892 31.1608 29.3976 31.9801C30.0141 32.7994 29.6004 35.8574 28.0753 35.8574C26.5503 35.8574 27.9942 31.6719 27.9942 31.6719Z"
        fill="#D57D7B"
      />
      <path
        d="M28.2538 30.8283C28.2538 27.3971 25.4795 25.1421 22.0562 25.1421C18.6329 25.1421 15.8586 27.389 15.8586 30.8283C15.8586 30.8283 15.5909 35.2085 15.5909 35.4194C15.5909 38.6803 19.5902 42.8253 22.0562 42.8253C24.9116 42.8253 28.5215 37.8935 28.5215 35.4194C28.5215 35.2085 28.2538 30.8283 28.2538 30.8283Z"
        fill="#E2847E"
      />
    </g>
    <mask
      id="mask1_4084_1903"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="45"
      y="0"
      width="56"
      height="56"
    >
      <circle cx="73" cy="28" r="28" fill="#B94C24" />
    </mask>
    <g mask="url(#mask1_4084_1903)">
      <rect
        x="36.04"
        y="-10.6399"
        width="110.88"
        height="105.84"
        fill="#D9D9D9"
      />
      <path
        d="M68.0961 17.6206C64.3609 17.6565 59.7115 19.6351 60.2567 25.7668C60.6388 30.0636 61.677 37.4165 64.5111 37.645C65.7648 37.7462 70.0616 36.1856 70.0616 36.1856L70.4208 41.3182L78.4821 39.1992L75.3183 32.545C75.3183 32.545 80.4052 17.5031 68.0961 17.6239V17.6206Z"
        fill="#FFEACC"
      />
      <path
        d="M61.5235 20.1739L68.8633 26.5603C69.34 24.5556 70.8778 24.647 71.9977 25.8714C73.3756 27.3798 71.6974 29.4205 72.0467 29.9592C72.3993 30.4946 74.8383 32.5973 75.3117 32.5418C75.7884 32.4863 83.4972 26.2011 76.8332 17.2354C73.7609 13.1018 65.3665 13.5785 61.5203 20.1739H61.5235Z"
        fill="#323232"
      />
      <path
        d="M65.187 10.8947C65.2718 13.843 67.1656 15.629 69.8494 15.5539C72.53 15.4788 73.6989 13.5165 73.6173 10.5682C73.5324 7.61985 72.0566 5.44535 69.3727 5.52044C66.6889 5.59554 65.1021 7.94309 65.187 10.8914V10.8947Z"
        fill="#323232"
      />
      <path
        d="M68.1516 38.6344L93.8833 32.3296C93.8833 32.3296 99.1106 48.6286 86.1582 49.3894C73.2091 50.1534 68.1549 38.6344 68.1549 38.6344H68.1516Z"
        fill="#66AFFF"
      />
      <path
        d="M75.178 37.8181C78.8805 38.0466 82.5177 38.9445 84.9045 45.9317C88.3066 55.557 90.713 72.3294 90.8011 104.16L60.5996 92.8599C63.7112 76.5478 62.4411 43.8649 68.1516 38.6376C70.5253 37.6385 72.0337 37.6254 75.178 37.8213V37.8181Z"
        fill="#66AFFF"
      />
    </g>
    <mask
      id="mask2_4084_1903"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="105"
      y="15"
      width="41"
      height="41"
    >
      <circle cx="125.5" cy="35.5" r="20.5" fill="#B94C24" />
    </mask>
    <g mask="url(#mask2_4084_1903)">
      <rect
        x="98.4399"
        y="7.20996"
        width="81.18"
        height="77.49"
        fill="#A2E6F5"
      />
      <path
        d="M123.783 53.4719C118.943 53.7719 112.689 52.1744 109.567 61.3283C107.175 77.8359 103.081 141.529 103.081 141.529L149.342 141.874C149.342 141.874 147.442 85.8002 141.653 61.3178C140.058 54.5721 136.452 56.5776 134.584 55.13C131.48 53.822 127.904 53.214 123.789 53.4693L123.783 53.4719Z"
        fill="#1D9AD2"
      />
      <path
        d="M117.164 67.6109C117.164 67.6109 104.477 61.5389 108.663 52.4929C112.849 43.4469 145.153 47.0395 144.953 55.0301C144.753 63.0181 129.202 68.6794 129.202 68.6794L117.166 67.6109H117.164Z"
        fill="#1D9AD2"
      />
      <path
        d="M115.881 38.6066C115.881 38.6066 114.131 32.7163 115.637 28.7868C117.534 23.844 126.566 18.3484 129.528 19.7249C132.492 21.1015 128.117 24.2545 129.465 24.6467C130.813 25.0389 131.63 21.9016 132.531 22.4832C136.174 24.8336 133.816 37.209 133.816 37.209L121.121 33.4006L115.881 38.6066Z"
        fill="#5B5B5B"
      />
      <path
        d="M129.943 55.1167L125.589 59.2647L121.232 55.1167L121.996 45.718H129.178L129.943 55.1167Z"
        fill="#F9C1AD"
      />
      <path
        d="M132.813 34.5297C132.316 30.0765 128.403 27.5629 123.97 28.0577C119.539 28.5525 116.27 31.8688 116.767 36.3195C116.767 36.3195 117.051 42.0387 117.082 42.3151C117.553 46.5472 123.321 51.3374 126.521 50.9795C130.216 50.5662 134.182 43.6495 133.824 40.4464C133.793 40.17 132.81 34.5271 132.81 34.5271L132.813 34.5297Z"
        fill="#F9C1AD"
      />
      <path
        d="M117.285 37.3801C117.285 37.3801 116.186 36.8326 115.511 37.9775C114.836 39.1251 115.805 43.0362 117.787 42.8151C119.768 42.594 117.282 37.3801 117.282 37.3801H117.285Z"
        fill="#F9C1AD"
      />
      <path
        d="M132.602 35.6695C132.602 35.6695 133.554 34.8931 134.465 35.8616C135.375 36.8328 135.291 40.8597 133.307 41.0808C131.325 41.3019 132.602 35.6695 132.602 35.6695Z"
        fill="#F9C1AD"
      />
      <g clipPath="url(#clip0_4084_1903)">
        <path
          d="M143.903 58.4503L116.121 63.0558L161.749 87.3885L150.065 61.7372C148.988 59.3727 146.463 58.0258 143.903 58.4501L143.903 58.4503Z"
          fill="#CEA23E"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4084_1903">
        <rect
          width="62.0538"
          height="62.1081"
          fill="white"
          transform="matrix(0.882375 0.470547 -0.469399 0.882986 122.635 39.7839)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(SyncoInvitePeopleIcon);
